<template>
  <button
    class="btn-nav"
    aria-label="next"
    @click="$store.dispatch('showNext', {n:loc, el:'#'+link})"
  >
    <!-- <slot></slot> -->
    <!-- <img src="@/assets/img/_ui/down-arrow.svg" width="30px" alt="" srcset=""> -->
    <!-- :class="{disabled: $store.state.currentLocation >= loc}"
    :disabled="$store.state.currentLocation >= loc" -->
  </button>
</template>

<script>
export default {
  props: {
    loc: Number,
    link: String
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">
/*------------------------------------*\
  #PRIMARY COLOURS
\*------------------------------------*/
@import '../styles/colors';

/*------------------------------------*\
  #Mixins
\*------------------------------------*/

/*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
\*------------------------------------*/
/**
* General Button Styling
*/
.btn-nav {
  // color: #333;
  // border: 1px solid #fff;
  // border-radius: 5px;
  background: transparent;
  padding: 10px 30px;
  margin: 2rem auto 1rem;
  display: block;
  width: 72px;
  height: 72px;
  // min-width: 150px;
  font-weight: 700;
  position: relative;
  // z-index: 1;
  transition: all 0.2s ease;
  font-size: 1rem;
  // text-transform: uppercase;
  // font-size: 1.2rem;

  // &:focus:enabled {
  //   background: $dark-grey;
  //   color: #fff;
  // }

  /**
  * Modifiers
  */
  &--disabled {
    opacity: 0.3;
    &:hover {
      display: none;
    }
  }

  &--white-2 {
    border: none;
    &::after {
      content: ' ';
      background: url('../assets/img/_ui/down-arrow-pnk-white.svg');
      background-repeat: no-repeat;
      position: absolute;
      width: 72px;
      height: 72px;
      top: 0px;
      left: 0px;
      transition: right 0.3s ease;
    }

    &:hover:enabled {
      // background: $blue;
      // color: #fff;
      // opacity: 0.9;
      &::after {
        content: ' ';
        background: url('../assets/img/_ui/down-arrow-pnk.svg');
      }
    }
  }

    &--white {
    border: none;
    &::after {
      content: ' ';
      background: url('../assets/img/_ui/down-button-wht.svg');
      background-repeat: no-repeat;
      position: absolute;
      width: 72px;
      height: 72px;
      top: 0px;
      left: 0px;
      transition: right 0.3s ease;
    }

    &:hover:enabled {
      // background: $blue;
      // color: #fff;
      // opacity: 0.9;
      &::after {
        content: ' ';
        background: url('../assets/img/_ui/down-button-blu.svg');
      }
    }
  }

  &--blue {
    // color: $blue;
    // border-color: $blue;
    // background: $blue;
    border: none;
    &::after {
      content: ' ';
      background: url('../assets/img/_ui/down-arrow-pnk.svg');
      background-repeat: no-repeat;
      position: absolute;
      width: 72px;
      height: 72px;
      top: 0px;
      left: 0px;
      transition: right 0.3s ease;
    }

    &:hover:enabled {
      // background: $blue;
      // color: #fff;
      // opacity: 0.9;
      &::after {
        content: ' ';
        background: url('../assets/img/_ui/down-arrow-pnk-white.svg');
      }
    }

    &:before {
      background-color: $blue;
    }
  }

  &--normal {
    border: 1px solid $blue;
    color: $blue;
    min-width: 150px;
    height: auto;
  }

  &--normal-white {
    border: 1px solid #fff;
    color: #fff;
    min-width: 150px;
    height: auto;
  }

  &--orange {
    color: $orange;
    border-color: $orange;
    // background: $orange;

    &:hover:enabled {
      background: $orange;
      color: #fff;
      // opacity: 0.9;
    }

    &:before {
      background-color: $orange;
    }
  }

  // &--purple {
  //   color: #fff;
  //   border-color: $purple;
  //   background: $purple;

  //   &:focus {
  //     background: #fff;
  //     color: $purple;
  //   }
  //   &:hover:enabled {
  //     background: $purple;
  //     color: #fff;
  //     border: 1px solid #fff;
  //     opacity: 0.9;
  //   }
  // }

  // &--green {
  //   color: #fff;
  //   border-color: $green;
  //   background: $green;

  //   &:focus {
  //     background: #fff;
  //     color: $green;
  //   }
  //   &:hover:enabled {
  //     background: $green;
  //     color: #fff;
  //     border: 1px solid #fff;
  //     opacity: 0.9;
  //   }
  // }

  // &--yellow {
  //   color: #fff;
  //   border-color: $yellow;
  //   background: $yellow;

  //   &:focus {
  //     background: #fff;
  //     color: $yellow;
  //   }
  //   &:hover:enabled {
  //     background: $yellow;
  //     color: #fff;
  //     border: 1px solid #fff;
  //     opacity: 0.9;
  //   }
  // }

  // &--red {
  //   color: #fff;
  //   // border-color: $red;
  //   border: none;
  //   background: linear-gradient(to right, $red, $dark-red);
  //   opacity: 1;
  //   text-decoration: none;
  //   &:hover {
  //     color: #fff;
  //     text-decoration: none;
  //   }
  //   &:hover:enabled {
  //     // background: $red;
  //     color: #fff;
  //     opacity: 0.9;
  //     text-decoration: none;
  //   }
  // }

  &--jumbo {
    font-size: 1.2rem;
    font-weight: 900;
    text-transform: uppercase;
    text-align: center;
    // max-width: 500px;
    text-decoration: none;
  }

  // &--orange {
  //   color: #fff;
  //   border-color: $orange;
  //   background: $orange;

  //   &:focus {
  //     background: #fff;
  //     color: $orange;
  //   }
  //   &:hover:enabled {
  //     background: $orange;
  //     color: #fff;
  //     border: 1px solid #fff;
  //     opacity: 0.9;
  //   }
  // }
}

.disabled {
  opacity: 0.3;
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  .btn-nav {
    &--jumbo {
      max-width: 500px;
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 992px
  (LAPTOP, TABLET)
\*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1200px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1320px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1600px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
